import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { GridListTile, CardMedia, Box, Typography } from '@material-ui/core';
import imgParams from '../../utils/imageUtil';
import { ellipsize } from '../../utils/textUtil';
import { useTablet, useDimensions } from '../../hooks/utilHooks';
import AnyLink from '../common/anyLink';

const ArticleContent = ({ post }) => {
  const classes = useStyles();
  const isTablet = useTablet();
  const { width, ref } = useDimensions();

  return (
    <React.Fragment>
      {post.articleImageUrl && (
        <GridListTile
          component="div"
          cols={2}
          rows={1}
          className={classes.gridListTitle}
        >
          <CardMedia
            ref={ref}
            className={classes.media}
            image={imgParams(post.articleImageUrl, width * 2, 340 * 2)}
            alt="article"
          />
          <Box className={classes.titleBar}>
            <Typography color="primary" variant="caption" component="div">
              {post.tags}
            </Typography>
            <AnyLink to={post.deepLinkUrl}>
              <Typography
                color="textPrimary"
                variant="subtitle2"
                component="div"
              >
                {ellipsize(post.title, isTablet ? 80 : 100)}
              </Typography>
            </AnyLink>
          </Box>
        </GridListTile>
      )}
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  media: {
    height: '320px',
    width: '100%',
    borderRadius: theme.spacing(3),
  },
  titleBar: {
    width: '96%',
    position: 'absolute',
    bottom: theme.spacing(2.5),
    left: theme.spacing(0),
    right: theme.spacing(0),
    margin: '0px auto',
    padding: theme.spacing(2, 4),
    background: theme.palette.background.default,
    borderRadius: theme.spacing(3),
  },
  gridListTitle: {
    padding: theme.spacing(0, 4),
    cursor: 'pointer',
  },
}));

export default ArticleContent;
